import { environment } from '../../../../environments/environment';

export const usePartnerTags = () => {
  return environment.production ? prodTags : stageTags;
};

const stageTags = [
  {
    id: '013715bc-2fec-4e68-89ed-309b173d8c48',
    name: 'NerdWallet',
  },
  {
    id: '7823fab1-f083-4266-b24c-799b6028751a',
    name: 'Wegmans',
  },
  {
    id: 'f0185753-92e3-4edd-9829-39cf9023953b',
    name: 'WorkMoney',
  },
  {
    id: 'dc244efa-7d30-4972-b1d3-adc1a8d2aa77',
    name: 'Healthcare',
  },
  {
    id: 'ddee068f-a616-466c-8b26-ed36f65c271d',
    name: 'Boldin',
  },
];

const prodTags = [
  {
    id: '069f8741-01fc-4123-b80e-6da4acc9ef20',
    name: 'NerdWallet',
  },
  {
    id: '84fbe512-28ed-4357-95c5-5a99d03af82a',
    name: 'Wegmans',
  },
  {
    id: '23532da6-3dcb-43a8-ae46-748f212b73e5',
    name: 'WorkMoney',
  },
  {
    id: '1e43d565-888c-4f5c-8c25-adbffabd026b',
    name: 'Healthcare',
  },
  {
    id: '2dd1946c-ee81-457f-90c9-c6ee371829e0',
    name: 'Boldin',
  },
  {
    id: '0c5ea0f5-c49e-4dbf-8d3a-498676922733',
    name: 'QuinStreet',
  },
  {
    id: '94c82f35-9ac0-4194-81f9-1631fe658517',
    name: 'PaloMedia',
  },
  {
    id: '97c2970c-4c78-4c3c-a623-47c967604914',
    name: 'LeadEconomy',
  },
  {
    id: '4fe172ae-0981-4674-ac13-efe07d2d3dc6',
    name: 'Sheridan',
  },
];
